import OSMTile from "@/model/OSMTile"

var UrlUtils = {
    extractOSMTileFromUrl: function(url, templateUrl) {
        if (url && templateUrl) {
            const urlParts = url.split("/");
            const templateUrlParts = templateUrl.split("/");

            if (urlParts.length !== templateUrlParts.length) {
                return null;
            } else {
                var index = 0;
                while (index < templateUrlParts.length) {
                    var templatePart = templateUrlParts[index];
                    var urlPart = urlParts[index];

                    var x;
                    var y;
                    var zoom;

                    if (templatePart.indexOf("{x}") >= 0) {
                        x = parseInt(this._extractTokenValue(urlPart, templatePart, "{x}"));
                    } else if (templatePart.indexOf("{y}") >= 0) {
                        y = parseInt(this._extractTokenValue(urlPart, templatePart, "{y}"));
                    } else if (templatePart.indexOf("{z}") >= 0) {
                        zoom = parseInt(this._extractTokenValue(urlPart, templatePart, "{z}"));
                    } else if (templatePart !== urlPart) {
                        return null;
                    }

                    index = index + 1;
                }

                if (x && y && zoom) {
                    return new OSMTile(x, y, zoom);
                }
            }
        } else {
            return null;
        }
    },

    buildUrlFromOSMTile: function(osmTile, templateUrl) {
        if (osmTile && templateUrl) {
            if (osmTile.x != null && osmTile.y != null && osmTile.zoom != null && osmTile.x >= 0 && osmTile.y >= 0 && osmTile.zoom >= 0) {
                var resultString = templateUrl.replace("{x}", osmTile.x);
                resultString = resultString.replace("{y}", osmTile.y);
                resultString = resultString.replace("{z}", osmTile.zoom);

                return resultString;
            } else {
                return null;
            }
        } else {
            return null;
        }
    },

    _extractTokenValue: function(fromString, templateString, token) {
        const tokenIndex = templateString.indexOf(token);
        const prefix = templateString.substring(0, tokenIndex);
        const suffix = templateString.substring(tokenIndex + token.length);

        var resultString = fromString.replace(prefix, "");
        resultString = resultString.replace(suffix, "");

        return resultString;
    }
};

export default UrlUtils;